import { render, staticRenderFns } from "./addCaseGoods.vue?vue&type=template&id=053cb545&scoped=true&"
import script from "./addCaseGoods.vue?vue&type=script&lang=js&"
export * from "./addCaseGoods.vue?vue&type=script&lang=js&"
import style0 from "./addCaseGoods.vue?vue&type=style&index=0&id=053cb545&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053cb545",
  null
  
)

export default component.exports